<template>
  <div class="introduce">
    <p align="center">暂无相关信息</p>
  </div>
</template>

<script>
export default {
  name: "11introduce",
};
</script>

<style scoped lang="scss">
@import "../scss/baseMain";
</style>
